import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ZodError } from 'zod';

@Injectable({ providedIn: 'root' })
export class Messenger {
  private bar = inject(MatSnackBar);

  info(msg: string) {
    return this.bar.open(msg, undefined, {
      horizontalPosition: 'end',
      duration: 10000,
    });
  }

  error(msg: string) {
    return this.bar.open(msg, 'Close', {
      horizontalPosition: 'end',
    });
  }

  handleHttpError = (err: HttpErrorResponse | ZodError) => {
    let message = 'Error';
    if (err instanceof HttpErrorResponse && err.error.errors) {
      message = err.error.errors.join('\n');
    } else if (err instanceof ZodError) {
      message = err.message;
    }

    this.error(message);
    console.error(err);
  };
}
